import React, { useEffect, useState } from 'react';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';


const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        hidecolFilter: true,
        action: true
    },
    {
        dataField: 'itemInvoicedDate',
        text: 'Invoiced Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter: false,
        cellRenderer: (rowData) => dateFormate(rowData.itemInvoicedDate),
    },
    {
        dataField: 'accountCode',
        text: 'Acct #',
        sort: false,
        width: 120,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.accountCode),
    },
    {
        dataField: 'wholesalerName',
        text: 'Wholesaler',
        sort: false,
        width: 180,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.wholesalerName),
    },
    {
        dataField: 'poid',
        text: 'PO #',
        sort: true,
        width: 100,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
    },
    {
        dataField: 'poType',
        text: 'PO Type',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.poType),
    },
    {
        dataField: 'packageInvoiced',
        text: 'Invoiced Qty',
        sort: true,
        width: 135,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.packageInvoiced),
    },
    {
        dataField: 'itemInvoiceNumber',
        text: 'Invoice #',
        sort: true,
        width: 120,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.itemInvoiceNumber),
    },
    {
        dataField: 'orderedPackagePrice',
        text: 'Pkg Price',
        sort: true,
        width: 120,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => currencyFormat(rowData.orderedPackagePrice),
    },
    {
        dataField: 'totalCost',
        text: 'Total Price',
        sort: false,
        width: 120,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData) => currencyFormat(rowData.totalCost),
    },
];


const PurchaseTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data?.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='configuration-table1'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination = {backUpData?.length>0 ?true : false}
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default PurchaseTable;
